export default "__VITE_ASSET__BTqwqods__"